import { fetchWithDefaultHeaders } from 'common/http';

export const VALIDATE_ENDPOINT_URL = '/process_discovery/validate_endpoint';

export const ValidationState = {
  Success: 'validation-success',
  Error: 'validation-error',
} as const;

export type ValidationState = (typeof ValidationState)[keyof typeof ValidationState];

export const testActionEndpoint = async (endpoint: string): Promise<ValidationState> => {
  try {
    const validateResponse = await fetchWithDefaultHeaders(VALIDATE_ENDPOINT_URL, {
      body: JSON.stringify({
        endpoint_url: endpoint,
      }),
      method: 'POST',
    });

    if (!validateResponse.ok) {
      return ValidationState.Error;
    }

    return ValidationState.Success;
  } catch {
    return ValidationState.Error;
  }
};
